





import { Component, Prop, Vue } from 'vue-property-decorator'; 
import { Action } from 'vuex-class'

@Component
export default class BotaoAdicionar extends Vue {
    @Prop() produto!: object
    @Prop() disponivel!: boolean 
    
    @Action('ATUALIZAR_CARRINHO')
    ATUALIZAR_CARRINHO!: (ATUALIZAR_CARRINHO: object) => void 

    @Action('TOGGLE_WINEBOX')
    TOGGLE_WINEBOX!: (TOGGLE_WINEBOX: void) => void 

    adicionarProduto(){ 
        this.ATUALIZAR_CARRINHO(
            {...this.produto, quantity: 1}
        );  
        this.TOGGLE_WINEBOX()
    }
 
}

